import React, { useEffect } from "react";
import { Modal, Button, Table } from "react-bootstrap";

const SalesDetailsModal = ({ show, handleClose, sale }) => {
	useEffect(() => {
	}, [])
	
	if (!sale) return null;

	return (
		<Modal show={show} onHide={handleClose} centered size="lg">
			<Modal.Header closeButton>
				<Modal.Title>Sales Details - {sale.invoiceNumber}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p><strong>Date:</strong> {sale.date}</p>
				<p><strong>Customer Name:</strong> {sale.customerName}</p>
				<p><strong>Payment Method:</strong> {sale.paymentMethod}</p>
				<p><strong>Status:</strong> {sale.status}</p>
				{sale.note && <p><strong>Note:</strong> {sale.note}</p>}

				<div className="table-responsive rounded">
					<Table bordered hover size="sm" className="mb-3">
						<thead>
							<tr>
								<th>Product Name</th>
								<th>Manufacturer</th>
								<th>Brand Name</th>
								<th>Quantity</th>
								<th>Product Type</th>
								<th>Price</th>
								<th>Amount</th>
								<th>Currency</th>
							</tr>
						</thead>
						<tbody>
							{sale.items && sale.items.length > 0 ? (
								sale.items?.map((item, idx) => (
									<tr key={idx}>
										<td>{item.productName}</td>
										<td>{item.manufacturer}</td>
										<td>{item.saltName}</td>
										<td>{item.quantity}</td>
										<td>{item.productType}</td>
										<td>{item.price}</td>
										<td>{item.currency} {item.amount}</td>
										{/* <td>{item.currency}</td> */}
									</tr>
								))
							) : (
								<tr>
									<td colSpan="5" style={{ textAlign: 'center' }}>
										No items found
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>

				<div className="table-responsive rounded">
					<Table bordered size="sm">
						<tbody>
							<tr>
								<td><strong>Subtotal</strong></td>
								<td>{sale.subtotal}</td>
							</tr>
							<tr>
								<td><strong>Tax</strong></td>
								<td>{sale.tax}</td>
							</tr>
							<tr>
								<td><strong>Transport Charge</strong></td>
								<td>{sale.transportCharge}</td>
							</tr>
							<tr>
								<td><strong>Discount</strong> ({sale.discountType})</td>
								<td>{sale.discount}</td>
							</tr>
							<tr>
								<td><strong>Total Amount</strong></td>
								<td>{sale.amount}</td>
							</tr>
							<tr>
								<td><strong>Paid Amount</strong></td>
								<td>{sale.paidAmount}</td>
							</tr>
							<tr>
								<td><strong>Due Amount</strong></td>
								<td>{sale.amount - sale.paidAmount}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={handleClose}>Close</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default SalesDetailsModal;
